import * as React from 'react';
import { useEffect, useState } from 'react';

import { useBOMProjectStore } from "../../../hooks/bom_project";
import useReduxState from "../../../hooks/useReduxState";
import EditProject from './EditProject';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import BomListUl from './BomListUl';
import { Drop } from "../../../component/DragAndDrop/Drop";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import Helper from 'src/support/Helper';

const ProjectList = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { fetch_bom_project_detail_with_bom }] = useBOMProjectStore();
    const [{ your_bom_listing, bom_project_list }, { }, { }] = useBOMProjectStore();
    const [activeToEditBOMProject, setActiveToEditBOMProject] = useReduxState({}, 'state_activeToEditBOMProject');
    const [find_bom_input_bom_listing] = useReduxState({}, 'find_bom_input_bom_listing');
    const [liveTotalCountIncludingProjects, setLiveTotalCountIncludingProjects] = useReduxState(0, 'BOM__liveTotalCountIncludingProjects');
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);

    useEffect(() => {
        async function fetchHere() {
            await fetch_bom_project_detail_with_bom();
            setFirstServerCall(false)
        }

        fetchHere()
    }, []);

    useEffect(() => {
        if (bom_project_list && Object.entries(bom_project_list).length > 0) {
            let count = 0
            Object.keys(bom_project_list).map((v) => {
                let res = getDisplayStatus(bom_project_list[v])

                if (res == true) {
                    count += 1
                }
            })

            if (count === 0) {
                setDefaultCountOfProject()
            }
        }
    }, [bom_project_list, find_bom_input_bom_listing]);
    
    useEffect(() => {
        if (firstServerCall === false && !monitorFunctionCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [your_bom_listing])

    const getDisplayStatus = (singleProject) => {
        if (find_bom_input_bom_listing.trim().length > 0) {
            let isBomMatch = false
            if (Object.keys(singleProject.bom_listing).length > 0) {
                Object.entries(singleProject.bom_listing).map((v) => {
                    if (v[1].bomName.toLowerCase().includes(find_bom_input_bom_listing.toLowerCase()) === true) {
                        isBomMatch = true;
                    }
                })
            }

            if (!isBomMatch) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    };

    const addProjectToEditStack = (singleProject) => {
        let a = { ...activeToEditBOMProject };
        if (a[singleProject.projectId] !== undefined) {
            delete a[singleProject.projectId];
        } else {
            a[singleProject.projectId] = singleProject;
        }
        setActiveToEditBOMProject(a);
    };

    const setDefaultCountOfProject = () => {
        let l = { ...liveTotalCountIncludingProjects };
        let validKeys = ['yourBOMNonID']
        /**
         * Author: Trilok Sain
         * Reason: count updated with undefined value therefore bug raise
         * Date: 03-02-2023
         */
        Object.keys(l).forEach((key) => !validKeys.includes(key) && delete l[key]);
        setLiveTotalCountIncludingProjects(l);
    }

    const setLiveTotal = () => {
        if (bom_project_list && Object.entries(bom_project_list).length > 0) {
            let count = 0
            let l = { ...liveTotalCountIncludingProjects };
            Object.keys(bom_project_list).map((v, key) => {
                let res = getDisplayStatus(bom_project_list[v])
                let bomCount = 0
                if (bom_project_list[v].bomList.length > 0) {
                    bom_project_list[v].bomList.map((k) => {
                        if (k.bomName.toLowerCase().includes(find_bom_input_bom_listing.toLowerCase()) === true) {

                            bomCount += 1
                        }
                    })
                }

                if (res == true) {
                    l[key] = bomCount;
                    count += 1
                }
            })

            if (count >= 0) {
                setLiveTotalCountIncludingProjects(l);
            }
        }
    }

    return (
        <>
            {bom_project_list && Object.entries(bom_project_list).length > 0 &&
                Object.entries(bom_project_list).map((v, i) => (
                    <React.Fragment key={v[1].projectId}>
                        {getDisplayStatus(v[1]) &&
                            <React.Fragment key={v[1].projectId}>
                                <Drop data={v[1]}>
                                    <div className="accordion mt-4 mb-3" id="test-project">
                                        <div className="accordion-item position-relative">
                                            <div>
                                                {__check(['BOM_PROJECT_API_CALL', 'BOM_ASSIGN_TO_PROJECT_API_CALL'], { overlay: true }).render}
                                            </div>
                                            <h2 className="accordion-header" id="headingOne">

                                                <button className="accordion-button" type="button" data-toggle="collapse"
                                                    data-target={"#collapse" + i} aria-expanded="true"
                                                    aria-controls={"collapse" + i}>
                                                    <b className="font-24 mt-3 ellipses" title={v[1].projectName}>{v[1].projectName}</b>
                                                </button>

                                            </h2>
                                            {activeToEditBOMProject[v[1].projectId] === undefined &&
                                                <p className="w-100 ps-3 m-b-20"><a className="text-blue2" href={void (0)}
                                                    onClick={async () => {
                                                        await addProjectToEditStack(v[1])
                                                    }}
                                                >Edit Project</a> / <a
                                                    className="text-blue2" data-toggle="modal" href={void (0)}
                                                    onClick={() => {
                                                        store.dispatch(system_notification({
                                                            name: 'BomDeleteProjectPopup',
                                                            data: {
                                                                projectId: v[1].projectId,
                                                                projectName: v[1].projectName
                                                            },
                                                        }));
                                                    }}>Delete Project</a></p>
                                            }
                                            {activeToEditBOMProject[v[1].projectId] !== undefined &&
                                                <EditProject projectData={v[1]}
                                                    addProjectToEditStack={(e) => addProjectToEditStack(e)} />
                                            }
                                            <div id={"collapse" + i} className="accordion-collapse collapse in"
                                                aria-labelledby="headingOne"
                                                data-parent="#accordionExample">
                                                <div className="accordion-body p-0">
                                                    { }
                                                    <BomListUl
                                                        liveTotalCountCallBack={(count) => {
                                                            setLiveTotal()
                                                        }}
                                                        bom_project_list_single={v[1]} listOfBOM={v[1].bom_listing}
                                                        project_id={v[1].projectId} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Drop>
                            </React.Fragment>
                        }
                    </React.Fragment >
                ))
            }
        </>
    );
}

export default ProjectList;